import { Separator } from '@/components/ui/separator';

type LoadingCheckoutPageProps = {
  bgFirst?: string;
  bgSecond?: string;
};

export default function LoadingCheckoutPage({ bgFirst, bgSecond }: LoadingCheckoutPageProps) {
  return (
    <>
      <div className='flex h-screen w-full flex-col md:flex-row'>
        <div
          className='flex w-full flex-col space-y-6 p-10 md:w-[55%]'
          style={{
            backgroundColor: bgFirst,
          }}
        >
          <div className='grid w-full grid-cols-3'>
            <div className='flex w-full gap-2'></div>
            <div className='flex w-full gap-2'>
              <div className='shimmering-loader h-5 w-52 rounded-lg' />
            </div>
            <div className='flex w-full gap-2'></div>
          </div>
          <div className='grid w-full grid-cols-3 gap-3'>
            <div className='flex w-full gap-2'>
              <div className='shimmering-loader h-16 w-52 rounded-lg' />
            </div>
            <div className='flex w-full gap-2'>
              <div className='shimmering-loader h-16 w-52 rounded-lg' />
            </div>
            <div className='flex w-full gap-2'>
              <div className='shimmering-loader h-16 w-52 rounded-lg' />
            </div>
          </div>
          <Separator className='my-6 h-0.5' />
          <div className='flex w-full flex-col'>
            <div className='shimmering-loader mb-5 h-8 w-32 rounded-lg' />
            <div className='shimmering-loader mb-3 h-5 w-full rounded-lg' />
            <div className='shimmering-loader mb-3 h-5 w-full rounded-lg' />
          </div>
          <Separator className='my-6 h-0.5' />
          <div className='flex w-full flex-col'>
            <div className='shimmering-loader mb-5 h-8 w-32 rounded-lg' />
            <div className='shimmering-loader mb-3 h-5 w-full rounded-lg' />
            <div className='shimmering-loader mb-3 h-5 w-full rounded-lg' />
          </div>
        </div>
        <div
          className='w-full space-y-6 p-10 md:w-[45%]'
          style={{
            backgroundColor: bgSecond,
          }}
        >
          <div className='flex items-center justify-between'>
            <div className='flex items-center gap-2'>
              <div className='shimmering-loader h-24 w-24 rounded-sm' />
              <div className='flex flex-col gap-2'>
                <div className='shimmering-loader h-5 w-52 rounded-sm' />
                <div className='shimmering-loader h-5 w-28 rounded-sm' />
              </div>
            </div>
            <div className='shimmering-loader h-5 w-28 rounded-sm' />
          </div>
          <div className='flex items-center justify-between'>
            <div className='shimmering-loader h-5 w-28 rounded-sm' />
            <div className='shimmering-loader h-5 w-28 rounded-sm' />
          </div>
          <div className='flex items-center justify-between'>
            <div className='shimmering-loader h-5 w-28 rounded-sm' />
            <div className='shimmering-loader h-5 w-28 rounded-sm' />
          </div>
          <div className='flex items-center justify-between'>
            <div className='shimmering-loader h-5 w-28 rounded-sm' />
            <div className='shimmering-loader h-5 w-28 rounded-sm' />
          </div>
          <div className='flex items-center justify-between gap-3'>
            <div className='shimmering-loader h-8 w-40 rounded-sm' />
            <div className='shimmering-loader h-8 w-40 rounded-sm' />
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .shimmering-loader {
            animation: shimmer 1.5s infinite linear;
            background: linear-gradient(to right, #d3d3d3 4%, #f5f5f5 25%, #d3d3d3 36%);
            background-size: 1000px 100%;
          }

          @keyframes shimmer {
            0% {
              background-position: -1000px 0;
            }
            100% {
              background-position: 1000px 0;
            }
          }
        `}
      </style>
    </>
  );
}
